"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERegisterOrAuthStatus = void 0;
let ERegisterOrAuthStatus = exports.ERegisterOrAuthStatus = /*#__PURE__*/function (ERegisterOrAuthStatus) {
  ERegisterOrAuthStatus["Initial"] = "initial";
  ERegisterOrAuthStatus["Loading"] = "loading";
  ERegisterOrAuthStatus["Succeed"] = "succeed";
  ERegisterOrAuthStatus["ManyAccounts"] = "manyAccounts";
  ERegisterOrAuthStatus["Failed"] = "failed";
  return ERegisterOrAuthStatus;
}({});